import { type FC, memo, useCallback, useState } from "react";
import { canv } from "@/canv/global";
import type { MoreStickersTool } from "@/tools/moreTool/MoreStickersTool";
import { EmojiPanel } from "./emoji";
import { addToPopularEmojis, getPopularEmojis } from "./emoji/lib";
import type { EmojiItem, UserEmoji } from "./emoji/model";

type EmojisProps = {
    searchQuery: string;
    onSearchReset: () => void;
};

export const Emojis: FC<EmojisProps> = memo(({ searchQuery, onSearchReset }) => {
    const [popularEmojis, setPopularEmojis] = useState<UserEmoji[]>(() => getPopularEmojis());

    const onEmojiClick = useCallback((emojiObject: EmojiItem) => {
        addToPopularEmojis(emojiObject.id, emojiObject.symbol);
        setPopularEmojis(getPopularEmojis());

        const moreStickerTool = canv.toolBox.TryGetToolByName(
            "moreStickerTool",
        ) as MoreStickersTool | null;
        if (moreStickerTool) {
            moreStickerTool.setEmoji(emojiObject.symbol);
            canv.toolBox.switchTo(moreStickerTool);
        }
    }, []);

    return (
        <EmojiPanel
            onEmojiClick={onEmojiClick}
            size="m"
            popularEmojis={popularEmojis}
            searchQuery={searchQuery}
            onSearchReset={onSearchReset}
        />
    );
});
